import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-rostering-addvehicle',
  templateUrl: './rostering-addvehicle.component.html',
  styleUrls: ['./rostering-addvehicle.component.css']
})
export class RosteringAddvehicleComponent implements OnInit {

  @Input() routeID;
  @Input() title = "'Vehicle Selection'";
  @Input() popup = false ;
  @Input('vehicleList') vehiclelists;
  @Input() public set selectedEmp(val:any){
    this.selectedEmpCounts = 0; 
    if(typeof(val)=='object') this.selectedEmpCounts = Object.keys(val).length;
  };
  @Input() public set selectedVeh(val:any){
    this.assignedVehicleCounts = 0;
    this.assignedVehicleSeats = 0;
    this.vehiclelists.filter((veh,i)=>{ 
      if(val.includes(veh.value)){
        this.assignedVehicleSeats+=Number(veh.badge);
        this.assignedVehicleCounts++;
        delete this.vehiclelists[i]; 
      } 
    });
    this.hideField = false;

  };
  @Input() unassignedEmp = [];

  public objectKeys = Object.keys;

  public selectedvehicles = [];
  public selectedVehicleCounts = 0;
  public selectedVehicleSeats = 0;

  public selectedEmpCounts = 0;

  public assignedVehicleCounts = 0;
  public assignedVehicleSeats = 0;
  public vehicles = [];

  public hideField:boolean = true;
  public optionTitlecase:boolean = false;
  
  @Output() generateVehicle: any = new EventEmitter();
  @Output() generateEmps: any = new EventEmitter();

  @Output() closeEvent: any = new EventEmitter();
  @Output() result: any = new EventEmitter();

  constructor(
    private api: ApiService,
    private swal: SweetAlert,
  ) { }

  ngOnInit(): void {

  }
  actionMulti(selected) {
    this.selectedvehicles = selected;
    this.vehicles = selected.map((veh) => { return veh.value; });
    this.selectedVehicleCounts = 0;
    this.selectedVehicleSeats = 0;
    selected.filter((veh)=>{
      this.selectedVehicleCounts++;
      this.selectedVehicleSeats+=Number(veh.badge);
    });
  }
  onSubmit(type){
    if(this.vehicles.length > 0){

      let obj = {
        routeID:this.routeID,
        vehicle:[...this.vehicles, ...this.selectedVeh],
      }
      this.api.transportMangerRouteUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          //this.swal.swalFunction(res.status, res.status, res.message, 2000);
          let vehicle = [];
          let emps = [];
          if(type == 'Generate'){
            this.generateVehicle.emit(this.vehicles);
            this.generateEmps.emit(this.unassignedEmp);
          }
          else if(type == 'Regenerate'){
            this.generateVehicle.emit(obj.vehicle);
            this.generateEmps.emit([...Object.values(this.selectedEmp), ...this.unassignedEmp]);
          }
          this.result.emit('generate route');
          this.closeEvent.emit(false);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }

}
